import Service from "./service.abstract";

export default class CategoryService extends Service {
    constructor(url: string) {
        super();

        this.url = url;
        this.errorTopic = "service.error.category";
    }
}